var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.productPage != 'true' ? 'maps' : ''},[_c('div',{class:_vm.productPage == 'true' ? 'mapContainerProduct' : 'mapContainerHome',attrs:{"dir":"ltr","id":"map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }